import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleAddAlternate.svg",
  "use": "CircleAddAlternate.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleAddAlternate.svg\"><path d=\"M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56Zm2-11a2,2,0,1,1-4,0V34H19a2,2,0,0,1,0-4H30V19a2,2,0,1,1,4,0V30H45a2,2,0,0,1,0,4H34Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol